module.exports = __webpack_public_path__ + "static/hero-ef9e923cfca5413bd960a00b3246d80a.svg";